export default "__VITE_ASSET__CBJnQWST__"